import { RefObject } from "react";

export const triggerFormSubmit = (formRef: RefObject<HTMLFormElement>) =>
  formRef.current?.dispatchEvent(
    // https://stackoverflow.com/a/66659749
    new Event("submit", { cancelable: true, bubbles: true })
  );
